import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CategoriaContaPagarEnum, CategoriaContaPagarLabel } from '../../../../../../core/enums/categoria-conta-pagar.enum';
import { TipoContaEnum } from '../../../../../../core/enums/tipo-conta.enum';
import { CategoriaContaReceberEnum, CategoriaContaReceberLabel } from '../../../../../../core/enums/categoria-conta-receber.enum';

@Component({
  selector: 'app-financeiro-modal-conta',
  templateUrl: './financeiro-modal-conta.component.html',
  styleUrls: ['./financeiro-modal-conta.component.css'],
  standalone: false
})
export class FinanceiroModalContaComponent {
  @Input() novaConta: any;
  @Input() pessoas: any = { itens: [] };
  @Output() fechar = new EventEmitter<void>();
  @Output() salvar = new EventEmitter<void>();

  errors: any = {};

  categoriasPagar = Object.keys(CategoriaContaPagarEnum)
    .filter(key => isNaN(Number(key)))
    .map(key => ({
      id: CategoriaContaPagarEnum[key as keyof typeof CategoriaContaPagarEnum],
      nome: CategoriaContaPagarLabel.get(CategoriaContaPagarEnum[key as keyof typeof CategoriaContaPagarEnum])
    }));

  categoriasReceber = Object.keys(CategoriaContaReceberEnum)
    .filter(key => isNaN(Number(key)))
    .map(key => ({
      id: CategoriaContaReceberEnum[key as keyof typeof CategoriaContaReceberEnum],
      nome: CategoriaContaReceberLabel.get(CategoriaContaReceberEnum[key as keyof typeof CategoriaContaReceberEnum])
    }));

  get isContaAPagar(): boolean {
    return this.novaConta.tipoConta === TipoContaEnum.ContaAPagar;
  }

  get isContaAReceber(): boolean {
    return this.novaConta.tipoConta === TipoContaEnum.ContaAReceber;
  }

  fecharModal() {
    this.errors = {};
    this.fechar.emit();
  }

  salvarConta() {
    if (this.validar()) {
      this.salvar.emit();
    }
  }

  validar(): boolean {
    this.errors = {};
    if (!this.novaConta.descricao) this.errors.descricao = true;
    if (!this.novaConta.valor) this.errors.valor = true;
    if (!this.novaConta.dataVencimento) this.errors.dataVencimento = true;
    if (this.novaConta.categoria === undefined || this.novaConta.categoria === null || this.novaConta.categoria === '') this.errors.categoria = true;

    return Object.keys(this.errors).length === 0;
  }
}
